import styled from '@emotion/styled';

import {
  COLOR_BORDER,
  COLOR_BORDER_SUBTLE,
  COLOR_SURFACE_HOVER,
  COLOR_SURFACE_MUTED,
  COLOR_TEXT_MUTED,
  COLOR_TEXT_PRIMARY,
} from './utils/variables';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    padding: 12px 16px;
    vertical-align: middle;
    text-align: left;
    box-sizing: border-box;
  }

  th {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: ${COLOR_TEXT_MUTED};
    background: ${COLOR_SURFACE_MUTED};
    border-bottom: 1px solid ${COLOR_BORDER};
    white-space: nowrap;
  }

  td {
    border-bottom: 1px solid ${COLOR_BORDER_SUBTLE};
    color: ${COLOR_TEXT_PRIMARY};
    font-size: 14px;
  }

  .col-status {
    width: 100px;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: ${COLOR_SURFACE_HOVER};
  }
`;
